import { render, staticRenderFns } from "./_base-header.vue?vue&type=template&id=e06fe5b2&scoped=true&"
import script from "./_base-header.vue?vue&type=script&lang=js&"
export * from "./_base-header.vue?vue&type=script&lang=js&"
import style0 from "./_base-header.vue?vue&type=style&index=0&id=e06fe5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06fe5b2",
  null
  
)

export default component.exports